import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider, CssBaseline } from '@mui/material'

import { store } from '@/app/store'
import { theme } from '@/app/theme'
import { App } from '@/App'
import { GlobalNotification } from '@/components/GlobalNotification'
import { SelfAnalyticsTracker } from '@/components/SelfAnalyticsTracker'

const root = document.getElementById('root')!
createRoot(root).render(
    <StrictMode>
        <Provider store={store}>
            <BrowserRouter>
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <App />
                    <SelfAnalyticsTracker />
                    <GlobalNotification />
                </ThemeProvider>
            </BrowserRouter>
        </Provider>
    </StrictMode>,
)
